@if (playSpacesReady$ | async) {
  <app-screen-shell
    contentWidth="standard"
    [contentInset]="showLocationsShellHeader() ? 'none' : 'page'"
    [contentClass]="locationsShellContentClass()"
    [showHeader]="showLocationsShellHeader()"
    [title]="locationsShellTitle()"
    [titleKey]="locationsShellTitleKey()"
    [backLabelKey]="locationsShellBackLabelKey()"
    (back)="handleLocationsShellBack()">
    <div class="locations-shell">
    @if (!editMode && !detailMode) {
      @if (!canLoadLocations()) {
        <section class="locations-setup-empty">
          <i [class]="'locations.location' | nogoshIcon" aria-hidden="true"></i>
          <h2>{{ 'locations.profileSetupTitle' | translate }}</h2>
          <p>{{ 'locations.profileSetupMessage' | translate }}</p>
          <button type="button" class="btn btn-primary" (click)="setProfileCity()">{{ 'events.addCity' | translate }}</button>
        </section>
      } @else {
      <section class="locations-toolbar" [attr.aria-label]="'locations.controls' | translate">
        <div class="locations-search-row">
          <label class="locations-search" for="locationSearch">
            <i [class]="'common.search' | nogoshIcon" aria-hidden="true"></i>
            <input
              id="locationSearch"
              type="search"
              name="locationSearch"
              [(ngModel)]="locationSearch"
              [placeholder]="'locations.searchPlaceholder' | translate"
              autocomplete="off" />
          </label>
          <button type="button" class="locations-add-button" (click)="editCreatePlayspace(null)" [attr.aria-label]="'locations.new' | translate">
            <i [class]="'common.plus' | nogoshIcon" aria-hidden="true"></i>
          </button>
        </div>

        <div class="locations-tabs" role="tablist" [attr.aria-label]="'locations.viewOptions' | translate">
          <button type="button" [class.active]="activeView === 'list'" (click)="setActiveView('list')">
            <i [class]="'locations.list' | nogoshIcon" aria-hidden="true"></i>
            <span>{{ 'locations.listView' | translate }}</span>
          </button>
          <button type="button" [class.active]="activeView === 'map'" (click)="setActiveView('map')">
            <i [class]="'locations.map' | nogoshIcon" aria-hidden="true"></i>
            <span>{{ 'locations.mapView' | translate }}</span>
          </button>
          <button type="button" [class.active]="activeView === 'mine'" (click)="setActiveView('mine')">
            <i [class]="'locations.mine' | nogoshIcon" aria-hidden="true"></i>
            <span>{{ 'locations.mineView' | translate }}</span>
          </button>
        </div>
      </section>

      <section class="locations-content" [class.locations-content-map-only]="activeView === 'map'">
        @if (activeView !== 'map') {
          <div class="locations-list-panel">
            @if (visiblePlaySpaces().length > 0) {
              <div class="locations-list">
                @for (m of visiblePlaySpaces(); track m.id || m.name) {
                  <button type="button" class="location-row" [class.active]="selectedPlaySpace && selectedPlaySpace.id === m.id" (click)="openPlaySpaceDetail(m)">
                    <span class="location-row-pin"><i [class]="'locations.location' | nogoshIcon" aria-hidden="true"></i></span>
                    <span class="location-row-main">
                      <span class="location-row-title">
                        <span>{{m.name}}</span>
                        @if (m.incompleteSetup === true) {
                          <span class="location-list-draft-badge" [title]="'locations.incompleteSetupTitle' | translate">
                            <i [class]="'common.edit' | nogoshIcon" aria-hidden="true"></i>
                            <span>{{ 'events.draft' | translate }}</span>
                          </span>
                        }
                      </span>
                      <span class="location-row-address">{{locationLine(m) || ('locations.addressMissing' | translate)}}</span>
                      <span class="location-row-meta">
                        @if (distanceLabel(m)) {
                          <span>{{distanceLabel(m)}}</span>
                        }
                        @if (isManagedByCurrentPlayer(m)) {
                          <span class="location-owner-chip">{{ 'locations.managedByYou' | translate }}</span>
                        }
                      </span>
                    </span>
                    <span class="location-row-chevron"><i [class]="'common.chevronRight' | nogoshIcon" aria-hidden="true"></i></span>
                  </button>
                }
              </div>
            } @else {
              <div class="locations-empty">
                <i [class]="'locations.distance' | nogoshIcon" aria-hidden="true"></i>
                <h2>{{ 'locations.emptyTitle' | translate }}</h2>
                <p>{{ activeView === 'mine' ? ('locations.emptyMine' | translate) : ('locations.emptyNearby' | translate) }}</p>
              </div>
            }
          </div>
        }

        <div class="locations-map-panel" [class.locations-map-panel-active]="activeView === 'map'">
          <google-map [options]="mapOptions" height="100%" width="100%">
            @for (m of locatedVisiblePlaySpaces(); track m.id || m.name; let i = $index) {
              <map-advanced-marker
                (markerInitialized)="bindPlaySpaceMarkerClick($event, m)"
                [options]="clickableAdvancedMarkerOptions"
                [position]="m.googleLatLng">
              </map-advanced-marker>
            }
          </google-map>
        </div>
      </section>
      }

    }

    @if (!editMode && detailMode && selectedPlaySpace) {
      <div class="location-detail-page" [class.location-detail-page-has-draft]="showIncompleteSetupNotice(selectedPlaySpace)">
        @if (showIncompleteSetupNotice(selectedPlaySpace)) {
          <div class="location-draft-notice" role="status">
            <span class="location-draft-icon" aria-hidden="true">
              <i [class]="'locations.location' | nogoshIcon"></i>
            </span>
            <span class="location-draft-copy">
              <strong>{{ 'locations.incompleteSetupTitle' | translate }}</strong>
              <span>{{ 'locations.incompleteSetupDescription' | translate }}</span>
            </span>
            <span class="location-draft-actions">
              <button type="button" class="location-draft-save" [disabled]="loading" (click)="saveIncompleteSetupLocation(selectedPlaySpace)">
                {{ 'locations.save' | translate }}
              </button>
              <button type="button" class="location-draft-cancel" [disabled]="loading" (click)="cancelIncompleteSetupLocation(selectedPlaySpace)">
                {{ 'common.cancel' | translate }}
              </button>
            </span>
          </div>
        }

        <div class="location-detail-sidebar">
        <section class="location-detail-card">
          <button type="button" class="location-detail-summary" (click)="openSelectedInMaps(selectedPlaySpace)" [attr.aria-label]="'locations.navigate' | translate">
            <span class="location-detail-pin"><i [class]="'locations.location' | nogoshIcon" aria-hidden="true"></i></span>
            <div>
              <span class="location-detail-label">{{ 'common.address' | translate }}</span>
              <strong>{{addressLine(selectedPlaySpace) || ('locations.addressMissing' | translate)}}</strong>
              @if (distanceLabel(selectedPlaySpace)) {
                <span class="location-detail-distance">{{distanceLabel(selectedPlaySpace)}}</span>
              }
            </div>
            <span class="location-detail-directions"><i [class]="'locations.directions' | nogoshIcon" aria-hidden="true"></i></span>
          </button>

          @if (hasLocationDetails(selectedPlaySpace)) {
          <div class="location-detail-list">
            @if (hasText(selectedPlaySpace.phone)) {
              <button type="button" class="location-detail-item location-detail-action-item" (click)="callPhone(selectedPlaySpace.phone)" [attr.aria-label]="'common.phone' | translate">
                <i [class]="'player.phone' | nogoshIcon" aria-hidden="true"></i>
                <span>{{ 'common.phone' | translate }}</span>
                <strong>{{selectedPlaySpace.phone}}</strong>
                <span class="location-detail-row-action"><i [class]="'player.phone' | nogoshIcon" aria-hidden="true"></i></span>
              </button>
            }
            @if (hasText(selectedPlaySpace.workingHours)) {
              <div class="location-detail-item">
                <i [class]="'locations.hours' | nogoshIcon" aria-hidden="true"></i>
                <span>{{ 'locations.workingHours' | translate }}</span>
                <strong>{{selectedPlaySpace.workingHours}}</strong>
              </div>
            }
            @if (hasText(creatorNickName(selectedPlaySpace))) {
              <button type="button" class="location-detail-item location-detail-action-item" [disabled]="!canChatWithCreator(selectedPlaySpace)" (click)="chatWithCreator(selectedPlaySpace)" [attr.aria-label]="'players.chat' | translate">
                <i [class]="'player.profile' | nogoshIcon" aria-hidden="true"></i>
                <span>{{ 'common.createdBy' | translate }}:</span>
                <strong>{{creatorNickName(selectedPlaySpace)}}</strong>
                @if (canChatWithCreator(selectedPlaySpace)) {
                  <span class="location-detail-row-action"><i [class]="'chat.chat' | nogoshIcon" aria-hidden="true"></i></span>
                }
              </button>
            }
          </div>
          }

          @if (selectedPlaySpace.webAddress) {
            <a class="location-detail-web-link" target="_blank" href="{{selectedPlaySpace.webAddress}}">
              <span><i [class]="'locations.website' | nogoshIcon" aria-hidden="true"></i></span>
              <strong>{{ 'locations.website' | translate }}</strong>
              <i [class]="'common.externalLink' | nogoshIcon" aria-hidden="true"></i>
            </a>
          }

          @if (isManagedByCurrentPlayer(selectedPlaySpace)) {
            <div class="location-detail-actions">
              <button type="button" class="location-detail-edit-action" (click)="editCreatePlayspace(selectedPlaySpace)">
                <span><i [class]="'common.edit' | nogoshIcon" aria-hidden="true"></i></span>
                <strong>{{ 'common.edit' | translate }}</strong>
                <i [class]="'common.chevronRight' | nogoshIcon" aria-hidden="true"></i>
              </button>
            </div>
          }
        </section>

        <section class="location-matches-card">
          <div class="location-matches-header">
            <h2>{{ 'locations.matchesTitle' | translate }}</h2>
            @if (!playSpaceSummaryLoading && playSpaceSummary && playSpaceSummary.eventCount > 0) {
              <span>{{ playSpaceSummary.eventCount }}</span>
            }
          </div>
          <p class="location-matches-copy">
            @if (!playSpaceSummaryLoading && playSpaceSummary && playSpaceSummary.eventCount > 0) {
              {{ 'locations.matchesFound' | translate }}
            } @else {
              {{ 'locations.matchesNone' | translate }}
            }
          </p>
          <button type="button" class="location-create-match-action" [disabled]="!!creatingMatchAtLocationId" (click)="createMatchAtLocation(selectedPlaySpace)">
            <span><i [class]="'match.soccer' | nogoshIcon" aria-hidden="true"></i></span>
            <strong>{{ 'locations.createMatchHere' | translate }}</strong>
            @if (creatingMatchAtLocationId === selectedPlaySpace.id) {
              <i [class]="('common.loading' | nogoshIcon) + ' nogosh-icon-spin'" aria-hidden="true"></i>
            } @else {
              <i [class]="'common.chevronRight' | nogoshIcon" aria-hidden="true"></i>
            }
          </button>
          @if (playSpaceSummary && playSpaceSummary.openMatches && playSpaceSummary.openMatches.length > 0) {
            <div class="location-match-links">
              @for (match of playSpaceSummary.openMatches; track match.id) {
                <button type="button" class="location-match-link" (click)="openLocationMatch(match)">
                  <span>{{match.name}}</span>
                  <i [class]="'common.chevronRight' | nogoshIcon" aria-hidden="true"></i>
                </button>
              }
            </div>
          }
        </section>
        </div>

        <section class="location-detail-map">
          <google-map [options]="detailMapOptions || mapOptions" height="100%" width="100%">
            @if (selectedPlaySpace.googleLatLng) {
              <map-advanced-marker
                [options]="clickableAdvancedMarkerOptions"
                [position]="selectedPlaySpace.googleLatLng">
              </map-advanced-marker>
            }
          </google-map>
        </section>
      </div>
    }

    @if (editMode) {
      <form (ngSubmit)="onSubmit()" autocomplete="off" #playSpaceForm="ngForm" class="location-form" [class.location-form-full]="editSection === 'all'" [class.location-form-has-draft]="showIncompleteSetupNotice(playSpace)">
        @if (showIncompleteSetupNotice(playSpace)) {
          <div class="location-draft-notice" role="status">
            <span class="location-draft-icon" aria-hidden="true">
              <i [class]="'locations.location' | nogoshIcon"></i>
            </span>
            <span class="location-draft-copy">
              <strong>{{ 'locations.incompleteSetupTitle' | translate }}</strong>
              <span>{{ 'locations.incompleteSetupDescription' | translate }}</span>
            </span>
            <span class="location-draft-actions">
              <button type="button" class="location-draft-save" [disabled]="loading" (click)="saveIncompleteSetupLocation(playSpace)">
                {{ 'locations.save' | translate }}
              </button>
              <button type="button" class="location-draft-cancel" [disabled]="loading" (click)="cancelIncompleteSetupLocation(playSpace)">
                {{ 'common.cancel' | translate }}
              </button>
            </span>
          </div>
        }

        @if (editSection === 'menu') {
          <section class="location-edit-menu">
            <button type="button" class="location-edit-menu-item" (click)="openEditSection('basic')">
              <span class="location-edit-menu-icon"><i [class]="'common.text' | nogoshIcon" aria-hidden="true"></i></span>
              <span>
                <strong>{{ 'locations.basicInfo' | translate }}</strong>
                <small>{{ playSpace.name }}</small>
              </span>
              <i [class]="'common.chevronRight' | nogoshIcon" aria-hidden="true"></i>
            </button>
            <button type="button" class="location-edit-menu-item" (click)="openEditSection('address')">
              <span class="location-edit-menu-icon"><i [class]="'locations.location' | nogoshIcon" aria-hidden="true"></i></span>
              <span>
                <strong>{{ 'common.address' | translate }}</strong>
                <small>{{ locationLine(playSpace) || ('locations.addressMissing' | translate) }}</small>
              </span>
              <i [class]="'common.chevronRight' | nogoshIcon" aria-hidden="true"></i>
            </button>
            <button type="button" class="location-edit-menu-item" (click)="openEditSection('contact')">
              <span class="location-edit-menu-icon"><i [class]="'locations.contact' | nogoshIcon" aria-hidden="true"></i></span>
              <span>
                <strong>{{ 'common.contact' | translate }}</strong>
                <small>{{ displayValue(playSpace.phone) }}</small>
              </span>
              <i [class]="'common.chevronRight' | nogoshIcon" aria-hidden="true"></i>
            </button>
            <button type="button" class="location-edit-menu-item" (click)="openEditSection('hours')">
              <span class="location-edit-menu-icon"><i [class]="'locations.hours' | nogoshIcon" aria-hidden="true"></i></span>
              <span>
                <strong>{{ 'locations.workingHours' | translate }}</strong>
                <small>{{ displayValue(playSpace.workingHours) }}</small>
              </span>
              <i [class]="'common.chevronRight' | nogoshIcon" aria-hidden="true"></i>
            </button>
            @if (isManagedByCurrentPlayer(playSpace)) {
              <button type="button" class="location-edit-menu-item location-edit-menu-item-danger" (click)="openDeleteSection()">
                <span class="location-edit-menu-icon"><i [class]="'common.delete' | nogoshIcon" aria-hidden="true"></i></span>
                <span>
                  <strong>{{ 'common.delete' | translate }}</strong>
                  <small>{{ 'locations.deleteMenuHint' | translate }}</small>
                </span>
                <i [class]="'common.chevronRight' | nogoshIcon" aria-hidden="true"></i>
              </button>
            }
          </section>
        }

        @if (editSection === 'all' || editSection === 'basic') {
        <section class="location-form-section">
          <h2>{{ 'locations.basicInfo' | translate }}</h2>
          <div class="form-group">
            <label for="psName">{{ 'common.name' | translate }}</label>
            <input type="text" class="form-control" [(ngModel)]="playSpace.name" [placeholder]="'validation.locationName' | translate" name="psName" id="psName" required>
          </div>
        </section>
        }

        @if (editSection === 'all' || editSection === 'address') {
        <section class="location-form-section">
          <h2>{{ 'common.address' | translate }}</h2>
          <div class="form-group">
            <label for="city">{{ 'common.city' | translate }}</label>
            <input [ngModel]="playSpaceCityName()"
              [placeholder]="'players.cityPlaceholder' | translate"
              name="city"
              class="form-control"
              id="city"
              autocomplete="off"
              readonly
              required
              type="text" />
          </div>
          <div class="form-group">
            <label for="address">{{ 'common.address' | translate }}</label>
            <div class="location-address-autocomplete">
              <input [ngModel]="playSpace.address"
                (ngModelChange)="onAddressInput($event)"
                (focus)="showAddressSuggestions()"
                (blur)="closeAddressSuggestionsLater()"
                [placeholder]="'validation.addressMap' | translate"
                name="address"
                class="form-control"
                [class.is-invalid]="!isAddressValidForSave()"
                id="address"
                autocomplete="off"
                required
                type="search" />
              @if (addressDropdownOpen) {
                <div class="location-address-suggestions" role="listbox">
                  @for (address of addressSuggestions; track address) {
                    <button type="button" class="location-address-suggestion" role="option" (mousedown)="$event.preventDefault()" (click)="selectAddress(address)">
                      {{ address }}
                    </button>
                  }
                </div>
              }
            </div>
            @if (!isAddressValidForSave()) {
              <small class="form-text text-danger">{{ 'players.addressSelectionRequired' | translate }}</small>
            }
          </div>
        </section>
        }

        @if (editSection === 'all' || editSection === 'address') {
        <section class="location-form-section">
          <h2>{{ 'locations.positionTitle' | translate }}</h2>
          <p class="location-form-hint">{{ 'locations.positionHint' | translate }}</p>
          <div class="location-edit-map">
            <google-map [options]="mapOptions" height="100%" width="100%" (mapClick)="mapUpdatePlayLocationInfo(null,  $event)">
              @if (playSpace.longitude && playSpace.latitude) {
                <map-advanced-marker
                  [position]="playSpace.googleLatLng"
                  [options]="clickableAdvancedMarkerOptions"
                  [gmpDraggable]="true"
                  (mapDragend)="mapUpdatePlayLocationInfo(null,  $event)">
                </map-advanced-marker>
              }
            </google-map>
          </div>
          <div class="location-coordinates">
            <i [class]="'common.target' | nogoshIcon" aria-hidden="true"></i>
            <span>{{playSpace.latitude}}, {{playSpace.longitude}}</span>
          </div>
        </section>
        }

        @if (editSection === 'all' || editSection === 'contact') {
        <section class="location-form-section">
          <h2>{{ 'common.contact' | translate }}</h2>
          <div class="form-group">
            <label for="phone">{{ 'common.phone' | translate }}</label>
            <input type="text" class="form-control" id="phone" [placeholder]="'validation.contactPhone' | translate"
              [(ngModel)]="playSpace.phone" name="phone">
          </div>
          <div class="form-group">
            <label for="web">{{ 'locations.webAddress' | translate }}</label>
            <input type="text" class="form-control" id="web" [placeholder]="'validation.webAddress' | translate"
              [(ngModel)]="playSpace.webAddress" name="web">
          </div>
        </section>
        }

        @if (editSection === 'all' || editSection === 'hours') {
        <section class="location-form-section">
          <h2>{{ 'locations.workingHours' | translate }}</h2>
          <div class="form-group">
            <label for="hours">{{ 'locations.workingHours' | translate }}</label>
            <input type="text" class="form-control" id="hours" [placeholder]="'validation.workingHours' | translate"
              [(ngModel)]="playSpace.workingHours" name="hours">
          </div>
        </section>
        }

        @if (editSection === 'all') {
        <section class="location-form-section">
          <h2>{{ 'common.createdBy' | translate }}</h2>
          <div class="form-group">
            <label for="manager">{{ 'common.createdBy' | translate }}</label>
            <input type="text" class="form-control" id="manager" disabled [ngModel]="playSpaceManagerName() || ('locations.noManager' | translate)" name="managerName">
          </div>
        </section>
        }

        @if (editSection === 'delete') {
        <section class="location-delete-screen">
          <div class="location-delete-icon"><i [class]="'common.delete' | nogoshIcon" aria-hidden="true"></i></div>
          <h2>{{ 'locations.deleteTitle' | translate }}</h2>
          <p>{{ 'locations.deleteDescription' | translate }}</p>

          <div class="location-delete-status">
            <span>{{ 'locations.connectedEvents' | translate }}</span>
            <strong>
              @if (deleteStatusLoading) {
                ...
              } @else {
                {{ deleteStatus ? deleteStatus.eventCount : '-' }}
              }
            </strong>
          </div>

          @if (!deleteStatusLoading && deleteStatus) {
            @if (deleteStatus.deletable) {
              <div class="location-delete-message location-delete-message-ok">
                <i [class]="'common.selected' | nogoshIcon" aria-hidden="true"></i>
                <span>{{ 'locations.deleteAllowed' | translate }}</span>
              </div>
            } @else {
              <div class="location-delete-message location-delete-message-blocked">
                <i [class]="'match.cancel' | nogoshIcon" aria-hidden="true"></i>
                <span>{{ 'locations.deleteBlocked' | translate }}</span>
              </div>
            }
          }

          @if (!deleteStatusLoading && hasManagedDeleteStatusMatches()) {
            <div class="location-delete-matches">
              <div class="location-delete-matches-title">{{ 'locations.managedMatches' | translate }}</div>
              @for (match of deleteStatus.managedMatches; track match.id) {
                <button type="button" class="location-delete-match-link" (click)="openLocationMatch(match)">
                  <span>{{ match.name }}</span>
                  <i [class]="'common.chevronRight' | nogoshIcon" aria-hidden="true"></i>
                </button>
              }
            </div>
          }

          <div class="location-delete-actions">
            <button type="button" class="btn btn-outline-danger" [disabled]="deleteStatusLoading || !deleteStatus || !deleteStatus.deletable" (click)="deletePlayspace()">
              <i [class]="'common.delete' | nogoshIcon" aria-hidden="true"></i>
              {{ 'common.delete' | translate }}
            </button>
          </div>
        </section>
        }

        @if (editSection !== 'menu') {
        <section appActionBar class="location-form-actions">
          <button type="button" class="btn btn-secondary" [disabled]="loading" (click)="cancelPlaySpaceEdit()">{{ 'common.cancel' | translate }}</button>
          @if (editSection !== 'delete') {
            <button appSaveAction [saved]="locationSaved" [saving]="loading" type="submit" class="btn btn-primary" [disabled]="loading || !playSpaceForm.form.valid || !isAddressValidForSave()">
              <i [class]="'common.save' | nogoshIcon" aria-hidden="true"></i>
              {{ 'common.save' | translate }}
            </button>
          }

        </section>
        }
      </form>
    }
    </div>
  </app-screen-shell>
}
